import { render, staticRenderFns } from "./setTonnageAndKilometer.vue?vue&type=template&id=6c8b74ec"
import script from "./setTonnageAndKilometer.vue?vue&type=script&lang=js"
export * from "./setTonnageAndKilometer.vue?vue&type=script&lang=js"
import style0 from "./setTonnageAndKilometer.vue?vue&type=style&index=0&id=6c8b74ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports